<template>
  <line-chart
    class="fill-height"
    :raw-data="periods"
    :chart-value-keys="[
      { key: 'HRMAX', label: $t('hr_variables.max_heart_rate'), type: 'line' },
      { key: 'HRAVG', type: 'bar', label: $t('hr_variables.avg_heart_rate') }
    ]"
    x-value="title"
    y-value-prefix="teams[0].team_stats."
    :yaxis="[ { title: { text: $t('hr_variables.hr_bpm') }, min: 0} ]"
    :xaxis="{
      labels: {
        rotate: -45
      },
      tickPlacement: 'between'
    }"
    :colors="['#FF4560', '#df7595']"
    :fill="{ opacity: [1, 1]}"
  >
    <template v-slot:header>
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.avg_max_heart_rate') }}
        </div>
        <v-btn
          v-if="removable"
          icon
          style="pointer-events: auto"
          @click="$emit('remove')"
        >
          <v-icon small>
            fal fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
    </template>
  </line-chart>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
  name: 'MaxAvgHeartRatePeriodChart',
  components: { LineChart },
  props: {
    periods: {
      type: Array,
      required: true
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  }
}
</script>
